import React, { Component } from "react";
import '../Configuration.css';
import { Box, Paper, TextField, Button, Stack, Tooltip, Grid, Autocomplete, Typography } from "@mui/material";
import CommonGridHeader, { CommonDeleteButton, DeletePopup } from "../../../Components/Common Components/CommonComponents";
import { DataGrid } from '@mui/x-data-grid';
import { withTranslation } from 'react-i18next';
import { ImagePaths } from "../../../Utility/ImagePaths";
import { Colors } from "../../../Styles/Colors";
import ToastMsg from '../../../Components/ToastMsg/ToastMsg';
import RestAPIService from "../../../Utility/Services/RestAPIService";
import { Serviceurls } from "../../../Utility/API/Serviceurls";
import { CheckAccessFunc } from "../../../Components/CommonFunctions/CommonFunctions";
import { localGetItem, localSetItem } from "../../../Utility/Services/CacheProviderService";

class PovMaster extends Component {
    constructor(props) {
        super(props);
        this.state = {
            selectedPov: null,
            current_page: 0,
            rowsPerPage: 10,
            showSuccessResponse: false,
            showErrorResponse: false,
            responseMessage: "",
            disableBtn: false,
            purposeOfVisit: "",
            purposeOfVisitID: null,
            povList: [],
            PovMasterList: []
        }
    }
    componentDidMount = () => {
        this.getGlobalPovList()
        this.getGlobalPovMasterList()
    }

    LoaderFunction = (key) => {
        this.setState({
            isLoader: key
        })
    }

    getGlobalPovList = () => {
        try {
            this.LoaderFunction(true)
            RestAPIService.getAll(Serviceurls.FO_POV_LIST + `?global_search=true`)
                .then(response => {
                    if (response.data.status === "success") {
                        this.setState({
                            povList: response.data.data,
                        }, () => {
                            this.LoaderFunction(false)
                        });
                    }
                })
                .catch(error => {
                    this.LoaderFunction(false)
                    if (error?.response?.data?.status === "fail") {
                        this.responseSuccessErrorMessage(error.response.data.message, false);
                    }
                });
        } catch (e) {
            this.LoaderFunction(false)
            this.responseSuccessErrorMessage(e.message, false);
        }
    }

    getGlobalPovMasterList = () => {
        try {
            this.LoaderFunction(true)
            RestAPIService.getAll(Serviceurls.FO_POV_LIST_MASTERS)
                .then(response => {
                    if (response.data.status === "success") {
                        this.setState({
                            PovMasterList: response.data.data,
                        }, () => {
                            this.LoaderFunction(false)
                        });
                    }
                })
                .catch(error => {
                    this.LoaderFunction(false)
                    if (error?.response?.data?.status === "fail") {
                        this.responseSuccessErrorMessage(error.response.data.message, false);
                    }
                });
        } catch (e) {
            this.LoaderFunction(false)
            this.responseSuccessErrorMessage(e.message, false);
        }
    }

    setPovList() {
        try {
            RestAPIService.getAll(Serviceurls.FO_POV_LIST).
                then((response) => {
                    if (response.data.status === "success") {
                        let data = response?.data && response?.data?.data?.length > 0 ? response.data.data : []
                        let PurposeOfVisitList = []
                        data.forEach(item => PurposeOfVisitList.push(item))
                        localSetItem("PurposeOfVisit", JSON.stringify(PurposeOfVisitList))
                    }
                    else {
                        this.responseSuccessErrorMessage(response.data.message, false)
                    }
                }).catch((error) => {
                    this.responseSuccessErrorMessage(error.message, false)
                })
        }
        catch (e) {
            this.responseSuccessErrorMessage(e.message, false)
        }
    }

    responseSuccessErrorMessage(message, type) {
        this.setState({
            showSuccessResponse: message ? type : false,
            showErrorResponse: message ? !type : false,
            responseMessage: message
        })
    }

    renderTextBox(label, statekey, value, options = []) {
        const { t } = this.props;
        return (
            <div id="eMed_srvConfig_divs" style={{ margin: '1vw' }}>
                <Autocomplete
                    disableClearable
                    value={value ? value : ""}
                    sx={{ width: "29.8vw" }}
                    size="small"
                    options={options?.length != 0 ? options : []}
                    getOptionLabel={option => typeof (option) === "string" ? option : statekey === "purposeOfVisit" ? option?.reason : option?.name}
                    onChange={(event, newValue) => {
                        if (newValue) {
                            if (statekey === "purposeOfVisit") {
                                this.setState({
                                    purposeOfVisit: newValue?.reason,
                                    purposeOfVisitID: newValue?.id,
                                })
                            }
                        }

                    }}
                    renderInput={(params) => (
                        <TextField
                            {...params}
                            label={t(label)}
                            name={statekey}
                            InputProps={{
                                ...params.InputProps
                            }}
                        />
                    )}
                />
            </div>
        )
    }
    handleClear = () => {
        this.setState({
            purposeOfVisit: "",
            selectedPov: null,
        })
    }

    handledelete = (data) => {
        this.setState({
            selectedPov: data ? data : null,
        })
    }

    handleSave = () => {
        const { t } = this.props
        let { purposeOfVisitID } = this.state;
        let isAvl = true;
        let Message = "";
        if (!purposeOfVisitID) { isAvl = false; Message = "Fillmandatory" }
        if (isAvl) {
            // api call
            let datas = {
                "pov_id": purposeOfVisitID ? purposeOfVisitID : null,
            }
            try {
                this.LoaderFunction(true)
                this.setState({ disableBtn: true })
                RestAPIService.create(datas, Serviceurls.FO_POV_LIST_MASTERS)
                    .then(response => {
                        if (response.data.status === "success") {
                            this.handleClear();
                            this.getGlobalPovMasterList();
                            this.setPovList()
                            this.LoaderFunction(false)
                            this.setState({ disableBtn: false })
                            this.responseSuccessErrorMessage(response.data.message, true);
                        }
                    })
                    .catch(error => {
                        if (error?.response?.data?.status === "fail") {
                            this.LoaderFunction(false)
                            this.setState({ disableBtn: false })
                            this.responseSuccessErrorMessage(error.response.data.message, false);
                        }
                    });
            } catch (e) {
                this.responseSuccessErrorMessage(e.message, false);
            }
        } else {
            this.responseSuccessErrorMessage(t(Message), false)
        }
    }

    msgClose() {
        this.setState({
            showSuccessResponse: false,
            showErrorResponse: false,
            responseMessage: ''
        })
    }

    popupClose() {
        this.setState({ selectedPov: null })
    }
    deletePov() {
        try {
            let data = {
                "pov_id": this.state.selectedPov ? this.state.selectedPov.id : null,
            }
            RestAPIService.delete(Serviceurls.FO_POV_LIST_MASTERS, data).
                then((response) => {
                    if (response.data.status === "success") {
                        this.responseSuccessErrorMessage(response.data.message, true)
                        this.setState({ selectedPov: null, }, () => {
                            this.getGlobalPovMasterList()
                            this.setPovList()
                            this.handleClear()
                        })
                    } else {
                        this.responseSuccessErrorMessage(response.data.message, false)
                    }
                }).catch(error => {
                    this.responseSuccessErrorMessage(error.message, false)
                })
        }
        catch (e) {
            this.responseSuccessErrorMessage(e.message, false)
        }
    }

    render() {
        const { t } = this.props;
        let { rowsPerPage, current_page, PovMasterList, purposeOfVisit } = this.state;
        const columns = [
            { field: 's.no', headerName: t('SNo'), sortable: false, flex: 0.15, renderCell: (index) => index.api.getRowIndex(index.row.id) + 1 },
            {
                field: 'pov_name', headerName: t('Purpose of Vsit'), sortable: false, flex: 0.65, renderCell: (params) => (
                    <Box component={'div'}>
                        {params?.row?.pov_name ? params?.row?.pov_name?.length > 25 ?
                            <Tooltip placement="top" title={params?.row?.pov_name}><Typography fontSize={'0.9vw'}>{params?.row?.pov_name?.slice(0, 25) + '...'}</Typography></Tooltip> :
                            <Typography fontSize={'0.9vw'}>{params?.row?.pov_name}</Typography> : '-'}
                    </Box>
                )
            },
            {
                field: 'actions', headerAlign: 'center', headerName: t('Action'), flex: 0.20, sortable: false, hideable: false, align: "center", renderCell: (params) => {
                    return (
                        <CommonDeleteButton
                            disable={!CheckAccessFunc("front_office", "Settings", "Hospital Configuration", "Purpose of Visit", "SubTab")?.editAccess}
                            size="1.5vw"
                            onClick={() => { this.handledelete(params?.row) }} />
                    )
                }
            }
        ]
        return (
            <Box id="eMed_srvConfig_Container" sx={{ backgroundColor: Colors.configHomeBg }}>
                <Grid container spacing={3} className="eMed_srvConfig_Box">
                    <Grid item xs={7.6}>
                        <Paper className="eMed_srvConfig_Div" >
                            <DataGrid
                                rows={PovMasterList}
                                columns={columns}
                                getRowId={(row) => row.id}
                                localeText={{
                                    toolbarColumns: "",
                                    toolbarDensity: "",
                                    toolbarExport: "",
                                    toolbarFilters: "",
                                    toolbarExportPrint: ""
                                }}
                                disableSelectionOnClick
                                components={{
                                    Toolbar: CommonGridHeader.CommonToolBar,
                                    NoRowsOverlay: () => {
                                        return (
                                            <Stack direction="row" justifyContent="center" alignItems="center" sx={{ height: "53vh" }}>
                                                {t("NoRecordsFound")}
                                            </Stack>
                                        )
                                    }
                                }}
                                headerHeight={40}
                                rowCount={PovMasterList.length}
                                page={current_page}
                                onPageChange={(newPage) => this.setState({ current_page: newPage })}
                                pageSize={rowsPerPage}
                                onPageSizeChange={(newPageSize) => this.setState({ rowsPerPage: newPageSize })}
                                rowsPerPageOptions={[10, 20, 30]}
                                pagination
                                loading={this.state.isLoader}
                            />
                        </Paper>
                    </Grid>
                    <Grid item xs={4.4}>
                        <Paper className="eMed_srvConfig_Div">
                            <div className='eMed_srvConfig_rightHead' style={{ backgroundColor: Colors.DataTblHeaderbg }}>
                                <p className='eMed_srvConfig_rightHead_txt'>{t('Purpose of Visit')}</p>
                            </div>
                            <div className="eMed_srvConfig_subDiv">
                                {this.renderTextBox('Purpose Of Visit *', "purposeOfVisit", purposeOfVisit, this.state.povList)}
                            </div>
                            <Stack spacing={2} direction="row" id='eMed_srvConfig_rightBtnCon' sx={{ backgroundColor: Colors.DataTblHeaderbg }} alignItems="center" justifyContent="center">
                                <Button variant='outlined' size="small" id="eMed_Config_btn" onClick={() => { this.handleClear() }}>{t("Clear")}</Button>
                                <Button disabled={this.state.disableBtn ? true : !CheckAccessFunc("front_office", "Settings", "Hospital Configuration", "Purpose of Visit", "SubTab")?.editAccess} variant='contained' size="small" id="eMed_Config_btn" emed_tid="Specializaton_Save_Btn" onClick={() => { this.handleSave() }}>{t("Save")}</Button>
                            </Stack>
                        </Paper>
                    </Grid>
                </Grid>
                {
                    this.state.showSuccessResponse ? <ToastMsg severity={"success"} msg={this.state.responseMessage} msgPop={this.msgClose.bind(this)} /> : null
                }
                {
                    this.state.showErrorResponse ? <ToastMsg severity={"error"} msg={this.state.responseMessage} msgPop={this.msgClose.bind(this)} /> : null
                }
                {this.state.selectedPov !== null ? <DeletePopup
                    DeletTitle={`${t("deleteMsg")} ${t("Pov - ")} ${this.state.selectedPov ? this.state.selectedPov?.pov_name : "-"} ?`}
                    deleteAlertPopupClose={this.popupClose.bind(this)}
                    removeData={this.deletePov.bind(this)}
                /> : null}
            </Box>
        )
    }
}
export default withTranslation()(PovMaster);